module.exports = __webpack_public_path__ + "static/media/chrome.8daafc83.ico";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/chrome.ico
// module id = 82
// module chunks = 0